module.exports = __webpack_public_path__ + "media/images/banner_example_desktop-f4d02fff385b33ec3006778def4c7fcf.png";